export default __webpack_public_path__ + "static/media/waiting-for-confirmation.ade7a0d9.png";